import { render, staticRenderFns } from "./ProjectsQuotesModal.vue?vue&type=template&id=877cd6d6&scoped=true"
import script from "./ProjectsQuotesModal.vue?vue&type=script&lang=js"
export * from "./ProjectsQuotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877cd6d6",
  null
  
)

export default component.exports